import Loadable from "react-loadable";

export const ApprovalStatus = Loadable({
  loader: () => import("../../../../modules/manage-pitch").then((module) => module.ApprovalStatus) as Promise<any>,
  loading: () => null,
});
